import {Component, EventEmitter, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule]
})
export class TileComponent{

  @Input() displayText : string;
  @Input() bgColor : string;
  @Input() showPointer : boolean = true;
  @Input() eqfLevel : string;
  @Output() onView : EventEmitter<any> = new EventEmitter<any>();
  @Output() onTileClick : EventEmitter<any> = new EventEmitter<any>();
  @Input() offSetMarginLeft : number = 0;
  @Input() showDetailIcon : boolean = true;
  @Input() showWarningIcon : boolean = false;


  get marginLeft(){
    const margin : number = 10 + this.offSetMarginLeft;
    return `${margin}px`;
  }

  get showEqfLevel(){
    return this.eqfLevel ? `(EQF ${this.eqfLevel})` : '';
  }

  get pointerCssClass(){
    return this.showPointer ? 'pointer' : '';
  }

  dispatchEvt(evt : any){
    evt.stopPropagation();
    evt.preventDefault();
    const domEvt = evt.target as HTMLElement;
    const type = domEvt.dataset['type'];
    if(type === "tile"){
      this.onTileClick.emit();
    }
    if(type === "icon"){
      this.onView.emit();
    }
  }

}
